import { useState, useRef } from "react";
import { Archive } from "lucide-react";

const THRESHOLD = 70;

export const SwipeDeleteRow = ({ item, onDelete, children, testid }) => {
  const [dx, setDx] = useState(0);
  const [swiping, setSwiping] = useState(false);
  const start = useRef({ x: 0, y: 0, active: false });
  const moved = useRef(false);

  const onTouchStart = (e) => {
    const t = e.touches[0];
    start.current = { x: t.clientX, y: t.clientY, active: true };
    moved.current = false;
  };
  const onTouchMove = (e) => {
    if (!start.current.active) return;
    const t = e.touches[0];
    const diffX = t.clientX - start.current.x;
    const diffY = t.clientY - start.current.y;
    if (Math.abs(diffX) < Math.abs(diffY)) return;
    if (Math.abs(diffX) > 8) moved.current = true;
    setSwiping(true);
    setDx(Math.max(-140, Math.min(0, diffX)));
  };
  const onTouchEnd = () => {
    if (!start.current.active) return;
    start.current.active = false;
    const d = dx;
    setSwiping(false);
    setDx(0);
    if (d <= -THRESHOLD) onDelete(item);
  };
  const onClickCapture = (e) => {
    if (moved.current) { e.stopPropagation(); e.preventDefault(); moved.current = false; }
  };

  return (
    <div className="relative overflow-hidden" data-testid={testid}>
      <div className="absolute inset-y-0 right-0 flex items-center gap-2 px-5 bg-amber-600 text-white text-xs font-semibold pointer-events-none"
        style={{ opacity: dx < -10 ? 1 : 0 }}>
        <Archive className="h-5 w-5" />Archivia
      </div>
      <div
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onClickCapture={onClickCapture}
        style={{ transform: `translateX(${dx}px)`, transition: swiping ? "none" : "transform 0.2s ease" }}
        className="relative bg-background"
      >
        {children}
      </div>
    </div>
  );
};
